/**
 * @generated SignedSource<<42a31023c6498c41f9e6a565fc3a29f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LeadStatusTypeEnum = "ConvertedToCustomer" | "InProgress" | "MarkAsSpam" | "NotConvertedToCustomer" | "Processed" | "Recieved";
export type UpdateLeadInputType = {
  leadIdGlobal: string;
  statusType?: LeadStatusTypeEnum | null | undefined;
};
export type saleByOwnerMutation$variables = {
  input: UpdateLeadInputType;
};
export type saleByOwnerMutation$data = {
  readonly updateLead: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly updatedObject: {
      readonly id: string;
      readonly statusType: LeadStatusTypeEnum | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type saleByOwnerMutation = {
  response: saleByOwnerMutation$data;
  variables: saleByOwnerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "saleByOwnerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LeadInterfaceUpdatedPayload",
        "kind": "LinkedField",
        "name": "updateLead",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "updatedObject",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "saleByOwnerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LeadInterfaceUpdatedPayload",
        "kind": "LinkedField",
        "name": "updateLead",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "updatedObject",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c637d28b3846fc311b23b5294aa4b84c",
    "id": null,
    "metadata": {},
    "name": "saleByOwnerMutation",
    "operationKind": "mutation",
    "text": "mutation saleByOwnerMutation(\n  $input: UpdateLeadInputType!\n) {\n  updateLead(input: $input) {\n    errors {\n      message\n      id\n    }\n    updatedObject {\n      __typename\n      statusType\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bdcaa6efe5de3cf8b2c9d907fb72f078";

export default node;
